import React, { Component } from 'react';
import '../adminDash.css';
import withNavigate from '../../Global_files/WithNavigate';
// import moment from 'moment-timezone';
import { post,get } from '../../custom_libraries/serverRequests';
import urls from '../../custom_libraries/urls';
import Alert from '@mui/material/Alert';
import CheckIcon from '@mui/icons-material/Check';
import Backdrop from '@mui/material/Backdrop';
// import CircularProgress from '@mui/material/CircularProgress';
import globalVariables from '../../custom_libraries/globalVariables';
import WebLogo from '../../assets/Artboard 1Bonus.png';

class ManageSite extends Component {
    constructor(props) {
        super(props);
        this.state = {
            sitename: '',
            address: '',
            city:'',
            street:'',
            zip:'',
            country:'',
            state:'',
            organisationName: '',
            //timezone: '',
            //timezones: [],
            warning_site: false,
            success_site: false,
            error_site: false,
            open_progress_bar: false,
            user_name:'',
            user_type:'',
            client_list:[],
            selected_Customers:[],
        };
    }

    componentDidMount() {
        this.setState({ user_name : localStorage.getItem(globalVariables.USER_NAME)});
        //  const timezones = moment.tz.names();
        // this.setState({ timezones });
        const user_type = localStorage.getItem(globalVariables.USER_TYPE);
        this.setState({ user_type }, () => {
        this.getCustomerList(); // Ensure this runs after state is updated
    });
    }

    handleInputChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    };

    getCustomerList = async () => {
        console.log("Fetching data from:", urls.GET_USERS);
        const {user_type} = this.state
        console.log("----user_type----", user_type);
        try {
            let access_token = localStorage.getItem(globalVariables.AUTH_TOKEN);
            
            
            console.log("--------auth token---------", access_token);
            let headers = {
                "content-type": "application/json",
                Authorization: `Bearer ${access_token}`
            };
            if (user_type === "DealerUser"){
                let dealer_id = localStorage.getItem(globalVariables.USER_ID);
                console.log("--------dealer_id---------", dealer_id);
                let url = urls.GET_USER_LIST_WITH_PERMISSIONS(dealer_id);
                console.log("--------url---------", url);
                const response = await get(url, headers); // API call
                console.log("--------response---------", response);

                // Validate the response and extract results
                if (!response || !response.results || !Array.isArray(response.results)) {
                    console.error("Invalid response or results:", response);
                    this.setState({ client_list: [] });
                    return;
                }
                this.setState({ client_list: response.results });
                console.log("user_list---------", this.state.client_list);
            }
            if (user_type === "TechnicianUser"){
                let dealer_uuid = localStorage.getItem(globalVariables.DEALER_UUID);
                console.log("--------dealer_uuid---------", dealer_uuid);
                let url = urls.GET_USER_LIST_WITH_PERMISSIONS(dealer_uuid);
                console.log("--------url---------", url);
                const response = await get(url, headers); // API call
                console.log("--------response---------", response);

                // Validate the response and extract results
                if (!response || !response.results || !Array.isArray(response.results)) {
                    console.error("Invalid response or results:", response);
                    this.setState({ client_list: [] });
                    return;
                }
                this.setState({ client_list: response.results });
                console.log("user_list---------", this.state.client_list);
            }
        } catch (error) {
            console.error("Error in getCustomerList:", error);
            this.setState({ client_list: [] });
        }
    };
    
    handleSelectionChange = (event) => {
        const selectedOptions = Array.from(event.target.selectedOptions, (option) => option.value);
        console.log("Selected Customers:", selectedOptions);
        this.setState({ selected_Customers: selectedOptions });
    };

    handleSiteSave = async () => {
        const { sitename, city, street, zip, organisationName, country, state, selected_Customers } = this.state;
        const address = `${street}, ${city}, ${zip} , ${country}, ${state}`;

        
        // Validation for required fields
        if (!sitename || !organisationName || !address) {
            this.setState({ warning_site: true });
            return;
        }

        let updatedSelectedCustomers = [...selected_Customers];
        updatedSelectedCustomers = [localStorage.getItem(globalVariables.USER_ID), ...updatedSelectedCustomers];  // Prepend logged-in user
        

        const data = JSON.stringify({
            sitename,
            address,
            organisation_name: organisationName,
            users: updatedSelectedCustomers,
        });

        console.log("Data to be saved:", data);
        this.startLoading()
        try{
            let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
            console.log("--------auth tocken---------", access_tocken);
            let headers = {
                // 'content-type': 'application/json',
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': `Bearer ${access_tocken}`
            }
            const response = await post(urls.SITE_MANAGE, data, headers);

            console.log("reposne of const===> ", response);
            if (response) {
                    this.setState({ success_site: true });
                
                // Delay for alert visibility before reload
                setTimeout(() => {
                    window.location.reload();
                }, 1500);
            }
            else{
                console.error('Error:');
                this.setState({ error_site: true });
            }
        }
        catch (error) {
            console.error('Error:', error);
            this.setState({ error_site: true});
        }
        this.stopLoading()
    };

    startLoading = () => {
        console.log("startloading")
    
        this.setState({ open_progress_bar: true })
    }
    
    stopLoading = () => {
        this.setState({ open_progress_bar: false })
    }

    render() {
        const {
            sitename,
            address,
            city,
            street,
            zip,
            state,
            organisationName,
            // timezone,
            // timezones,
            warning_site,
            success_site,
            error_site, 
            client_list,
            selected_Customers ,
            country,
        } = this.state;

        return (
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                <div className="side-by-side-container" style={{ flex: '5', marginLeft: '20%', marginTop: '2%', padding: '15px', overflowY: 'auto' }}>
                    <div className="client-container">
                        <div className="form-section" style={{ padding: "12px" }}>
                            <h3>Add New Site </h3>
                            {warning_site && (
                                <Alert severity="warning">Please fill all the required fields.</Alert>
                            )}
                            {error_site && (
                                <Alert severity="error">Server Error! Could not save site information.</Alert>
                            )}
                            {success_site && (
                                <Alert icon={<CheckIcon fontSize="inherit" />} severity="success">
                                    Site information saved successfully.
                                </Alert>
                            )}
                            
                            <input
                                type="text"
                                name="sitename"
                                placeholder="Site Name *"
                                value={sitename}
                                onChange={this.handleInputChange}
                                style={{ width: '98%', marginBottom: '10px', padding: '8px' }}
                            />
                            <input
                                type="text"
                                name="organisationName"
                                placeholder="Organisation Name *"
                                value={organisationName}
                                onChange={this.handleInputChange}
                                style={{ width: '98%', marginBottom: '10px', padding: '8px' }}
                            />
                            <input
                                type="text"
                                name="street"
                                placeholder="Address *"
                                value={street}
                                onChange={this.handleInputChange}
                                style={{ width: '34%', marginBottom: '10px', padding: '8px' }}
                            />
                            <input
                                type="text"
                                name="city"
                                placeholder="City *"
                                value={city}
                                onChange={this.handleInputChange}
                                style={{ width: '34%', marginBottom: '10px', padding: '8px', marginLeft:'4px' }}
                            />
                            <input
                                type="text"
                                name="zip"
                                placeholder="Zip *"
                                value={zip}
                                onChange={this.handleInputChange}
                                // style={{ width: '25%', marginBottom: '10px', padding: '8px', marginLeft:'3px' }}
                                style={{ width: '25%', marginBottom: '11px', padding: '8px', fontSize: '13px', marginLeft:'3px' }}
                            />
                            <input
                                type="text"
                                name="state"
                                placeholder="State *"
                                value={state}
                                onChange={this.handleInputChange}
                                style={{ width: '46.5%', marginBottom: '10px', padding: '8px' }}
                            />

                            <input
                                type="text"
                                name="country"
                                placeholder="Country *"
                                value={country}
                                onChange={this.handleInputChange}
                                // style={{ width: '25%', marginBottom: '10px', padding: '8px', marginLeft:'3px' }}
                                style={{ width: '49%', marginBottom: '11px', padding: '8px', marginLeft:'3px', fontSize: '13px' }}
                        />

                            
                            
                            <label style={{fontSize: '15px'}}> Select Customer/s :</label>
                            <select
                                name='customers'
                                multiple
                                onChange={this.handleSelectionChange}
                                style={{ width: '100%', marginBottom: '15px', marginTop:'5px', padding: '8px', fontSize: '13px' }}
                            >
                                {client_list.map((customer) => (
                                    <option
                                        key={customer.user_id}
                                        value={customer.user_id}
                                    >
                                        {customer.first_name} - {customer.email}
                                    </option>
                                ))}
                            </select>

                            <button
                                type="button"
                                onClick={this.handleSiteSave}
                                style={{ padding: '10px 20px', fontSize: '16px' }}
                            >
                                <b>Save</b>
                            </button>
                            {/* Backdrop with Circular Progress */}
                            <Backdrop open={this.state.open_progress_bar}>
                            <div className="custom-spinner">
                                <div className="circle"></div>
                                <div className="circle tilted"></div>
                                <img src={WebLogo} alt="web-logo" style={{backgroundColor:'#001f54', borderRadius:'100px'}}/>
                            </div>
                            {/* <CircularProgress size={80} color="inherit" /> */}
                            </Backdrop>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withNavigate(ManageSite);